import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'
import {
  FileCopy as FileCopyBase,
  HelpOutline as HelpOutlineBase,
  Visibility as VisibilityBase
} from '@mui/icons-material'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
`

export const Strong = styled('strong')``

export const Italic = styled('span')`
  font-style: italic;
`

export const Label = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  font-style: italic;
  line-height: 24px;
  margin: 0;
`

export const Clipboard = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.black1};
  border-radius: 4px;
  box-sizing: border-box;
  cursor: pointer;
  display: grid;
  grid-template-columns: auto 45px;
  padding: 4px 0 4px 16px;
  width: 100%;
`

export const ClipboardText = styled('div')`
  color: ${props => props.theme.palette.brand.white};
  font-family: Coda;
  font-size: 14px;
  line-height: 24px;
  overflow: hidden;
  pointer-events: none;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
`

export const ClipboardAction = styled('div')`
  display: flex;
  justify-content: center;
  pointer-events: none;
  user-select: none;
`

export const ClipboardIcon = styled(FileCopyBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.white};
    font-size: 1.1rem;
    pointer-events: none;
    user-select: none;
  }
`

export const Info = styled('div')`
  align-items: center;
  cursor: pointer;
  display: inline-grid;
  grid-template-columns: 20px auto;
  height: 20px;
  margin: 4px 20px 8px 0;
`

export const InfoText = styled('div')`
  color: ${props => props.theme.palette.brand.black3};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 0 8px;
  pointer-events: none;
  user-select: none;

  ${Info}:hover & {
    text-decoration: underline;
  }
`

export const BuildIcon = styled(HelpOutlineBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 1.5rem;
    pointer-events: none;
    user-select: none;
  }
`

export const PreviewIcon = styled(VisibilityBase)`
  &.MuiSvgIcon-root {
    fill: ${props => props.theme.palette.brand.black3};
    font-size: 1.5rem;
    pointer-events: none;
    user-select: none;
  }
`

export const DialogTitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: normal;
  line-height: 21px;
  margin: 0;
`

export const DialogDescription = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 21px;
  margin: 0;
`

export const DialogList = styled('ul')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 21px;
  margin: 0;
  padding: 0 0 0 15px;
`

export const DialogItem = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 21px;
`

export const DialogField = styled('div')`
  align-items: center;
  background-color: ${props => props.theme.palette.brand.black1};
  border-radius: 4px;
  box-sizing: border-box;
  color: ${props => props.theme.palette.brand.white};
  display: inline-flex;
  font-family: Coda;
  font-size: 14px;
  justify-content: flex-start;
  max-width: 617px;
  overflow: hidden;
  padding: 4px 16px;
  pointer-events: none;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const DialogText = styled('span')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
`

export const DialogLink = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`
export const TableContainer = styled('div')`
  overflow-x: auto;
`
